import { action } from 'mobx';
import { Auth } from 'api';
import { isProduction } from 'utils/constants';
import userStore from './UserStore';

class AuthStore {
  @action
  signIn = data => {
    if (!isProduction) {
      return Promise.resolve();
    }

    return Auth.signIn(data);
  };

  @action
  signOut = () => {
    userStore.resetUserData();
  };

  @action
  sendCode = data => {
    return Auth.sendCode(data);
  };

  @action
  resendCode = async data => {
    await Auth.sendCode(data);
  };
}

const authStore = new AuthStore();

export default authStore;
